import { reduxActions as ATTRIBUTE } from "_constants/attribute.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";
import initialAttributeState from "../attribute.initialState";

const all = {
  [ATTRIBUTE.ALL_STARTED]: (state) => ({
    ...state,
    all: {
      ...state.all,
      status: LOADING
    }
  }),

  [ATTRIBUTE.ALL_SUCCESS]: (state, { payload }) => ({
    ...state,
    all: {
      ...state.all,
      data: payload?.data?.sort((a, b) => (a?.index - b?.index)) ?? null,
      status: SUCCESS
    }
  }),

  [ATTRIBUTE.ALL_FAIL]: (state, { payload }) => ({
    ...state,
    all: {
      ...state.all,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [ATTRIBUTE.ALL_RESET]: (state) => ({
    ...state,
    all: initialAttributeState.all
  })
}

export default all;
